export const SEARCH_PATHNAME = '/search/';
export const SEARCH_INDEX_NAME = 'global_search';
export const SEARCH_INDEX_PREFIX_PROD = 'prod';
export const SEARCH_INDEX_PREFIX_DEV = 'preview';
export const SEARCH_TITLE = 'Search';
export const SEARCH_DEBOUNCE_TIME = 200;
export const PREFIX_URL_SONARSOURCE_COM = 'https://www.sonarsource.com';
export const SEARCH_SORT_OPTIONS = {
  relevance: '',
  oldest: 'lastModified_asc',
  newest: 'lastModified_desc',
};
